import { useNavigate } from "react-router-dom"

import { scrollToTop } from "../../../../utils/submitApplication/submitApplicationUtils"

/**
 * Exposes a function that handles the click event of the navigation button.
 * If the button is an external link, it will open the link in a new tab.
 * Otherwise, it will navigate to the route using react-router-dom. Side
 * effects can be added to the function by passing a function to the
 * onClickSideEffect parameter.
 *
 */
export const useClickNavButton = (
    route: string,
    external?: boolean,
    onClickSideEffect?: () => void
): {
    clickNavButton: () => void
} => {
    const navigate = useNavigate()

    const clickNavButton = (): void => {
        if (external) {
            window.open(route, "_blank")
        } else {
            scrollToTop(document)
            navigate(route)
        }

        if (onClickSideEffect) onClickSideEffect()
    }

    return { clickNavButton }
}
